import React from "react";
import { useTranslation } from "react-i18next";

import contactImage from "./images/contactImage.png";

const ContactList = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="container mt-4">
        <h2 className="text-center mb-4"><strong>Contact</strong></h2>

        <div className="row align-items-center justify-content-center">

          {/* Image Column */}
          <div className="col-md-12 text-center mb-4">
            <img
              src={contactImage}
              className="img-fluid"
              alt="contact"
              style={{
                maxHeight: "400px",
                objectFit: "contain",
              }}
            />
          </div>

          {/* Contact Info Column */}
          <div className="col-md-12 m-5">
            <ul className="list-unstyled fs-5">
              <li className="mb-3">• 📧 Email: <a href="mailto:contact@stratedgeos.lu">contact@stratedgeos.lu</a></li>
              <li className="mb-3">• 📍 Address: 55, rue de Luxembourg ; L-4391 Pontpierre; Luxembourg</li>
              <li className="mb-3">• 📞 Phone: <a href="tel:+352661189465">+352 661 189 465</a></li>
            </ul>
            <p className="fst-italic">Ajouter l’adresse sur Google Maps :</p>
          </div>

        </div>
      </div>

      {/* Map Section */}
      <h2 className="text-center m-4"><strong>{t("location")}</strong></h2>
      <div
        className="mt-4"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "500px",
        }}
      >
        <iframe 
        title="Adresse StartEdge"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2589.1074446312523!2d6.031472976285177!3d49.539124171432555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47954a0b58840b5f%3A0x1080bd5820fd0b1a!2s55%20Rue%20de%20Luxembourg%2C%204391%20Pontpierre%20Mondercange%2C%20Luxembourg!5e0!3m2!1sen!2stn!4v1753628123943!5m2!1sen!2stn" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </>
  );
};

export default ContactList;
